import CardsApi from '../api/CardsApi';
import CardsConstants from '../constants/CardsConstants';

export function searchCards({ metadataIds, searchType, query, limit, ...filters }) {
  return {
    types: [
      CardsConstants.SEARCH_CARDS_REQUEST,
      CardsConstants.SEARCH_CARDS_SUCCESS,
      CardsConstants.SEARCH_CARDS_FAILURE
    ],
    // Prevent global failure messaging
    // because user has no context as to what failed
    apiFailure: () => ({ messaging: null }),
    apiRequest: (_state, apiClient) =>
      CardsApi.searchCards(
        {
          filters,
          limit,
          metadataIds,
          query,
          searchType
        },
        apiClient
      )
  };
}

export default {
  searchCards
};
